module.exports = __webpack_public_path__ + "static/media/printer.3748812f.svg";